/**
 * StarterPrompts Component
 *
 * Status: [IMPLEMENTED]
 * Task: T6.1-T6.5 - Conversation Starters (Feature 6)
 *
 * Pre-written prompts that visitors can click to start conversations.
 * Reduces the blank-page problem and guides visitors to high-value questions.
 */

import React from 'react';

const starterPrompts = [
  "What are Raja's technical skills?",
  "Tell me about Raja's projects",
  "What AI tools is Raja building?",
  "How does Raja use Claude Code day to day?",
  "Show me Raja's automation work",
];

function StarterPrompts({ onSelect, compact = false }) {
  // Compact mode: inline dropdown style
  if (compact) {
    return (
      <div className="flex flex-wrap gap-2 justify-start">
        {starterPrompts.map((prompt, index) => (
          <button
            key={index}
            onClick={() => onSelect(prompt)}
            className="px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600
                       hover:bg-sky-50 dark:hover:bg-sky-900 hover:border-sky-300 dark:hover:border-sky-700
                       hover:text-sky-700 dark:hover:text-sky-300
                       text-slate-600 dark:text-slate-300 text-xs rounded-full transition-colors"
          >
            {prompt}
          </button>
        ))}
      </div>
    );
  }

  // Full mode: centered with instructions (initial state)
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-4">
      <div className="text-center mb-6">
        <p className="text-slate-500 dark:text-slate-400 text-sm">
          Not sure where to start? Try one of these:
        </p>
      </div>

      <div className="flex flex-wrap gap-2 justify-center max-w-md">
        {starterPrompts.map((prompt, index) => (
          <button
            key={index}
            onClick={() => onSelect(prompt)}
            className="px-4 py-2 bg-slate-100 dark:bg-slate-700 hover:bg-sky-100 dark:hover:bg-sky-900
                       hover:text-sky-700 dark:hover:text-sky-300
                       text-slate-600 dark:text-slate-300 text-sm rounded-full transition-colors
                       min-h-[44px] touch-manipulation"
          >
            {prompt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default StarterPrompts;
